import React, { useEffect, useState } from 'react';
import i18next from '../i18n'
const errorMessages = {
    BAD_REQUEST: i18next.t('BAD_REQUEST'),
    NOT_FOUND: i18next.t('NOT_FOUND'),
    INTERNAL_SERVER_ERROR: i18next.t('INTERNAL_SERVER_ERROR'),
    SERVICE_UNAVAILABLE: i18next.t('SERVICE_UNAVAILABLE'),
    DEFAULT: i18next.t('DEFAULT')
};

const ErrorMessage = ({ error }) => {
    const [opacity, setOpacity] = useState(0);

    useEffect(() => {
        if (error) {
            // エラーがセットされたときにフェードイン開始
            setOpacity(0);  // 一度リセット（optional）
            setTimeout(() => {
                setOpacity(1);
            }, 10); // 短い遅延でトリガー
        } else {
            // エラーが消えたときは非表示
            setOpacity(0);
        }
    }, [error]);

    if (!error) return null;

    const errorCode = error?.response?.data?.error_code;
    const serverMessage = error?.response?.data?.message;



    // 翻訳はレンダーごとに取る
    const message = (() => {
        if (errorCode) {
            const translated = i18next.t(errorCode);
            return translated !== errorCode ? translated : i18next.t('DEFAULT');

        }
        return i18next.t('DEFAULT');
    })();

    return (
        <p
            style={{
                color: 'red',
                fontWeight: 'bold',
                transition: 'opacity 0.5s ease-in-out',
                opacity: opacity
            }}
        >
            {serverMessage}
            {/* {message} */}
        </p>
    );
};

export default ErrorMessage;
